module.exports = __webpack_public_path__ + "img/Hypoxia-BRCA_SpatialResearch.cb500a96.png";